import { Timestamp, WithRef } from '@principle-theorem/shared';
import { IClinicalChart } from './clinical-charting/clinical-chart';

export interface IHistoryItem<T> {
  label: string;
  timestamp: Timestamp;
  value: T;
}

export type IChartHistoryItem = IHistoryItem<WithRef<IClinicalChart>>;
